import * as Config from '../config';
import { useEffect } from 'react';
import { connect } from "react-redux";

import { setHistoryTracks } from "../actions/index";

// Store `Tracks Saved In Local Storage` Management
let saveToLocal = false;
function ConnectedRecentTracksWrapper({ historyTracks, setHistoryTracks }) {

  useEffect( () => {
    if (saveToLocal) {
      localStorage.setItem('LSTracks', JSON.stringify(historyTracks));
    }
  }, [historyTracks]);

  useEffect( () => {
    const LSTracks = JSON.parse(localStorage.getItem('LSTracks'));
    saveToLocal = true;
    if (LSTracks) {
      const max = Config.RECENT_TRACKS_LIMIT;
      setHistoryTracks(LSTracks.slice(0, max)); //Limit for performance
    }
  }, [setHistoryTracks]);

  return null;
}

const RecentTracksWrapper = connect(
  state => ({
    historyTracks: state.historyTracks
  }),
  dispatch => ({
    setHistoryTracks: data => dispatch(setHistoryTracks(data))
  })
)(ConnectedRecentTracksWrapper);

export default RecentTracksWrapper;
